import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFacultiesStart } from "../../redux/faculties/reducer";
import { selectFaculties, facultiesLoading } from "../../redux/faculties/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";

const useFacultiesGet = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(facultiesLoading);
  const faculties = useSelector(selectFaculties);

  const [fetch, setFetch] = useState(0);

  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const refetch = useCallback(() => setFetch((prev) => prev + 1), []);

  const fetchFaculties = useCallback(() => {
    dispatch(
      getFacultiesStart({
        keyword: debouncedSearchText,
        size: limit,
        page: (page - 1) ,
      })
    );
  }, [dispatch, page, limit, debouncedSearchText]);

  useEffect(() => {
    fetchFaculties();
  }, [fetchFaculties, fetch]);

  useEffect(() => {
    if (faculties) {
      setPageable({
        total_elements: faculties?.count,
        total_pages: faculties?.pages,
        number_of_elements: faculties?.items?.length,
      });
    }
  }, [faculties, setPageable]);

  return {
    faculties,
    loadingFaculties: isLoading,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  };
};

export default useFacultiesGet;
